<template>
  <v-dialog v-model="value" width="600" persistent>
    <v-card class="w-100 rounded-lg">
      <v-card-title>{{ $t('spedilink.groups.filter') }}</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="localFilters.name"
          :label="$t('spedilink.groups.name')"
          outlined
          dense
          hide-details
          class="mb-2"
          clearable
        />
        <v-text-field
          v-model="localFilters.description"
          :label="$t('spedilink.groups.description')"
          outlined
          dense
          hide-details
          class="mb-2"
          clearable
        />
      </v-card-text>
      <v-card-actions class="d-flex px-4 pb-4">
        <v-btn outlined @click="close()">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn color="primary" class="ml-auto" depressed @click="applyFilter()">
          {{ $t('spedilink.groups.filter') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SpediLinkGroupsFilterDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  computed: {
    localFilters: {
      get () {
        return this.filters
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    applyFilter () {
      this.$emit('filter', this.filters)
    }
  }
}
</script>
